import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { hasTrackingConsent, initTracking, trackPageView } from '../lib/tracking';

const AnalyticsManager = () => {
  const location = useLocation();

  useEffect(() => {
    const syncTracking = () => {
      if (!hasTrackingConsent()) return;
      initTracking();
      trackPageView(`${window.location.pathname}${window.location.search}`);
    };

    syncTracking();
    window.addEventListener('neuralia-consent-updated', syncTracking);

    return () => {
      window.removeEventListener('neuralia-consent-updated', syncTracking);
    };
  }, []);

  useEffect(() => {
    if (!hasTrackingConsent()) return;
    initTracking();
    trackPageView(`${location.pathname}${location.search}`);
  }, [location.pathname, location.search]);

  return null;
};

export default AnalyticsManager;